import React, { Component } from 'react';
import { Link } from "react-router-dom";
import Pagination from "react-js-pagination";
import $ from 'jquery';
import {
  Table
} from "react-bootstrap"; 

import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import {apiUrl} from'../Config/Config';
import axios from 'axios';
import 'react-confirm-alert/src/react-confirm-alert.css'; 
import { lang } from '../Helpers/lang';
class List extends Component {
  
  constructor(props)
  {
    super(props);
    this.state = {
      guidelist:'',
      activePage:1,
      sno_index:0,
      selectedStatus:'',
      selectid:'',
    };
    


    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    

    componentDidMount() {
      this.listloadedData()      
   }

   listloadedData(postobject='') {
      var qs = require('qs');
      var admin_id = localStorage.getItem("admin_id");
      var loggedas = localStorage.getItem("loggedas");

      if(postobject!=''){
        var postobject = postobject;
      }else{
        var postobject = {
        activePage: 1,
        search_all: '',
        admin_id: admin_id,
        loggedas: loggedas
        };  
      }

      axios.post(apiUrl+"guide/list",qs.stringify(postobject)).then(res => {
        if(res.data.status === 'success'){         
            this.setState({  guidelist: res.data.guidelist, totalRecord: res.data.records_count}, function() {
            //console.log('afa');
              this.guidelist();
            });  
        }else{         
          this.setState({  guidelist: '', totalRecord: 0}, function() {            
            this.guidelist();
          });
        }
      }); 
   }

   handlePageChange(pageNumber) {
    // console.log(`active page is ${pageNumber}`);
     this.setState({activePage: pageNumber});
     var sno_index = pageNumber - 1;
     this.setState({sno_index: sno_index});

     var qs = require('qs');

     var admin_id = localStorage.getItem("admin_id");
     var loggedas = localStorage.getItem("loggedas");
     var postobject = {
       activePage: pageNumber,
       search_all: this.state.search_all,
       admin_id: admin_id,
       loggedas:loggedas
     };
    //  this.props.getguidelist(qs.stringify(postobject))
    this.listloadedData(postobject)

   }

  handleInputChange(event) {
    const {name, value} = event.target; 
    var postObject = {             
      activePage   : this.state.activePage,
      search_all : value,
      admin_id: localStorage.getItem('admin_id')           
    };
    this.setState({
      [name]: value
    },function(){
      this.handleFormSubmit(postObject)
    });
  }

 handleFormSubmit = () => {
        
  this.setState({Loading:true});
  var qs = require('qs');
  const formPayload = this.state;
   var admin_id = localStorage.getItem("admin_id");
   var loggedas = localStorage.getItem("loggedas");
  var postObject = {             
    activePage   : 1,
    search_all : formPayload.search_all,
    admin_id: admin_id,
    loggedas: loggedas         
  };
  this.listloadedData(postObject)
} 

activeguide(){
  let stat = ''
  if(this.state.selectedStatus ==='inactive'){
      stat = "I";
    }else{
      stat = "A";
    }
        var qs = require('qs');
        var postObject = {
          admin_id : localStorage.getItem("admin_id"),
          id  :this.state.selectid,
          status: stat
        };

       
          this.change_status(postObject);
        

      // this.props.getactiveamenity(qs.stringify(postObject));
      
}

confirmPopup = (id, status) => {
    var status = status;
    if(status == 'inactive'){
        status = "active";
    }else if(status == "active"){
        status = "inactive";
    }else{
        status = "delete"
    }
    
    
    this.setState({selectid: id, selectedStatus: status})	
    $('.confirm-action').addClass('show');		
}

Confirmstatus = (confirmstatus) => {
  
  if(confirmstatus == 'yes'){
    console.log(confirmstatus , "confirmstatus from /guide/List.js ");
    // if(this.state.selectedStatus=='delete'){
    //   this.deleteguide();
    // }else{
    //   this.activeguide();
    // }
   
    $('.confirm-action').removeClass('show');
  }else{
    $('.confirm-action').removeClass('show');	
  }
    
}
deleteguide(){
   
  var qs = require('qs');
  var postObject = {
    admin_id : localStorage.getItem("admin_id"),
    id  :this.state.selectid,
   
  };

axios.post(apiUrl+"guide/delete",qs.stringify(postObject)).then(res => {
  if(res.data.status === 'success'){
    var postobject1 = {
      activePage: this.state.activePage,
      search_all: '',
      admin_id : localStorage.getItem("admin_id")
    };
    this.listloadedData(postobject1)

   
    $('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message +'</h3></div>');
    setTimeout(
      function() {
     
        $('.success_message').html('');
         
      }
      .bind(this),
      3000
      );
      
}
}); 
}

change_status(postObject){
  var qs = require('qs');
  axios.post(apiUrl+"guide/change_status",qs.stringify(postObject)).then(res1 => {
    if(res1.data.status === 'success'){
      this.listloadedData()
     $('.success_message').html('<div class="status_sucess"><h3>'+ res1.data.message +'</h3></div>');
              setTimeout(
                function() {
               
                  $('.success_message').html('');
                   
                }
                .bind(this),
                3000
                );
    }
  }); 
}


guidelist() {
    var guidelist = this.state.guidelist;
    var sno_index = this.state.sno_index;
    if (guidelist != "undefined" && guidelist != null) {
      console.log(guidelist);
    
      if (guidelist.length > 0) {

        if (Object.keys(guidelist).length > 0) {
          const helperlistDetails = guidelist.map(
            (guidelist, Index) => {
              if(sno_index > 0){ Index = (sno_index * 10) + Index; } 
              let sno = Index+1;
              

               if(guidelist.status == 'A'){
                var status = 'active';
              }else{
                  status = 'inactive';
              }
             
              return (
                <tr key={guidelist.id}>
      					<td>{sno}</td>
      					<td>{guidelist.cate_name}</td>
      					<td>{guidelist.sub_cate_name}</td>
      					<td>{guidelist.name}</td>
                
                <td>{lang.Capitalize(status)}</td>
                <td className="actiongroup" >
                    
                    
                     {/* <Link to={{ pathname: '/faq-view/'+guidelist.id}} className="" title="View">  <i className="ft-eye" aria-hidden="true"></i></Link> */}
                    <Link to={{ pathname: '/guide-edit/'+guidelist.id}} className="" title="Edit">  <i className="ft-edit-3" aria-hidden="true"></i></Link>
                    {(status == 'active'?<Link onClick={this.confirmPopup.bind(this, guidelist.id, status)} className="" title="Status"><i className="ft-unlock" aria-hidden="true"></i></Link>:<Link onClick={this.confirmPopup.bind(this, guidelist.id, status)} className="" title="Status"><i className="ft-lock" aria-hidden="true"></i></Link>)}      

                   

                     <Link onClick={this.confirmPopup.bind(this,guidelist.id,'delete')} className="" title="Delete"><i className="ft-trash-2" aria-hidden="true"></i></Link>
                    
                  </td>
                </tr>
              );
            }
          );
          return helperlistDetails;
        }
      } else {
        return (
          <tr>
            <td colspan="11" className="v-align-nr">
              No Result
            </td>
          </tr>
        );
      }
    }else {
      return (
        <tr>
          <td colspan="11" className="v-align-nr">
            No Result
          </td>
        </tr>
      );
    }
  }
  


  render() {

    const {} = this.state;
	  var current = this;
    var admin_id = localStorage.getItem('admin_id');
   let catImg = '';
  let preview = '';
    return (
      <div className="wrapper"> 
 <div className="confirm-action">
			<p>Are you sure! you want to {this.state.selectedStatus} Guide?</p>
			<a href="javascript://" onClick={this.Confirmstatus.bind(this, "yes")} className="btn">Yes</a>
			<a href="javascript://" onClick={this.Confirmstatus.bind(this, "no")} className="btn">No</a>
		</div>
    <Header />
    <MenuSidebar currentpage="guide" /> 
      <div className="content"> 
        <div className="content-wrapper">
        <div class="content-wrapper-before"></div>
   
         <div className="car-listing-wrap leaa-admin-head card">
            <div className="success_message"></div>
              <div className="listing-header">
                <div className="title">
                  <h3>Guide</h3>
                </div>
               

                <div className="search-list">
                   <form className="edit" id="edit" onSubmit={ e => { this.handleFormSubmit(this); e.preventDefault(); }} >     
                    <div className="search-inner">
                      <input type="text" name="search_all" onChange={this.handleInputChange} className="form-control" value={this.state.search_all} placeholder="Search" /> 
                     <button className="" type="submit">Submit</button>
                    <div className="erroremail"></div>
                  </div>
                 </form>
                </div>
                 <div className="add_button">  
                    <a className="" href='/guide-add'>Add</a>
                </div>
                </div>      
                         
              <div style={{color:"green", fontSize: 30}} className="statusmessage"></div>
            
              <div className="car-listing-row">
              <div className="overflow">
                <Table striped bordered hover>
                  <thead>
                  <tr>
                  <th width="80">S.No</th>
			            <th>Category</th>
			            <th>Sub Category</th>
			            <th>Title</th>
                  <th>Status</th>
                  <th width="130">Action</th>
                   </tr>
                  </thead>
                  <tbody>{this.guidelist()}</tbody>
                </Table>
			        	</div>
                <div className="text-center">
                  <Pagination
                  activePage={this.state.activePage}
                  itemsCountPerPage={10}
                  totalItemsCount={this.state.totalRecord}
                  pageRangeDisplayed={5}
                  onChange={this.handlePageChange.bind(this)}
                  />
                </div>
              </div>

            </div> 
        </div>  
      </div>
      
    </div>
    );
  }
}
export default List;